// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__4Ld7b","loadingIcon":"Loading_loadingIcon__2TiYA","rotating":"Loading_rotating__39Nby"};